import React from "react";
import { Outlet } from "react-router-dom";

/**
 * SuccessPageLayout: Used for Success Pages .
 * Renders main content
 */
const SuccessPageLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex flex-col">
      <main className="flex-1 overflow-auto overflow-x-hidden">
        {children ? children : <Outlet />}
      </main>
    </div>
  );
};

export default SuccessPageLayout;
